import React from 'react';

export const ActiveCampaignForm = () => (
  <form method="POST" action="https://dappuniversity288.activehosted.com/proc.php" id="_form_27_" className="_form _form_27 _inline-form  _dark" noValidate data-styles-version="4">
    <input type="hidden" name="u" value="27" />
    <input type="hidden" name="f" value="27" />
    <input type="hidden" name="s" />
    <input type="hidden" name="c" value="0" />
    <input type="hidden" name="m" value="0" />
    <input type="hidden" name="act" value="sub" />
    <input type="hidden" name="v" value="2" />
    <input type="hidden" name="or" value="0011be8bf28c3410f6106abe9057ba41" />
    <div className="_form-content">
      <div className="_form_element _x99753823 _full_width ">
        {/* <label htmlFor="firstname" className="_form-label" /> */}
        <div className="_field-wrapper">
          <label htmlFor="firstname" className="_form-label" aria-label="Name">
            <input type="text" id="firstname" name="firstname" placeholder="Enter Name" required />
          </label>
        </div>
      </div>
      <div className="_form_element _x48672327 _full_width ">
        {/* <label htmlFor="email" className="_form-label" /> */}
        <div className="_field-wrapper">
          <label htmlFor="email" className="_form-label" aria-label="email">
            <input type="text" id="email" name="email" placeholder="Enter Email" required />
          </label>
        </div>
      </div>
      <div className="_button-wrapper _full_width">
        <button id="_form_27_submit" className="_submit" type="submit">
          Hold your spot
        </button>
      </div>
      <div className="_clear-element" />
    </div>
    <div className="_form-thank-you" style={{ display: 'none' }} />
  </form>
);
